
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import validateEmail from '../../common/validateEmail';
import DialogAlert from './DialogAlert';
import useAuth from '../hooks/useAuth';
import { getActions as authGetActions } from '../sagas/auth';

const classNames = mergeStyleSets({
    ResetPasswordRequestForm: {
        backgroundColor: '#ffffff',
        width: '400px',
        padding: '16px'
    },
});


const ResetPasswordRequestForm = ({onCancelClick}) => {

    const dispatch = useDispatch();
    const authActions = authGetActions(dispatch);

    const auth = useAuth();

    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');

    const checkParams = () => {
        let errors = [];
        if (!username) {
            errors.push('Uživatelské jméno musí být zadané');
        }
        if (!email) {
            errors.push('E-mailová adresa musí být zadaný');
        }
        if (!validateEmail(email)) {
            errors.push('E-mailová adresa není platná');
        }

        return errors;
    }

    const handleCancelClick = () => {
        if (onCancelClick) {
            onCancelClick();
        }
    }

    const handleSenedRequestClick = async (event) => {
        let errors = checkParams();
        if (errors.length === 0) {
            authActions.resetPasswordRequest(username, email);
        } else {
            await DialogAlert.show(errors.reduce(
                (previous, current) => {
                    return previous + `- ${current}<br/>`;
                }, 'Nejsou splněny následující podmínky a proto nelze pokračovat v obnově hesla:<br/></br/>'),
                {minWidth: 500});
        }
    }

    const handleChangeUsername = (event) => {
        setUsername(event.target.value);
    }

    const handleChangeEmail = (event) => {
        setEmail(event.target.value);
    }

    return (
        <Stack className={classNames.ResetPasswordRequestForm} tokens={{childrenGap: 16}}>
            <Stack.Item>
                <TextField
                    label="Uživatelské jméno"
                    disabled={auth.operationLoading}
                    onChange={handleChangeUsername}
                />
                <TextField
                    label="E-mailová adresa"
                    disabled={auth.operationLoading}
                    onChange={handleChangeEmail}
                />
            </Stack.Item>
            <div>
                <>E-mailová adresa musí být stejná jako byla uvedena při registraci uživatelského účtu. </>
                <>Na tuto e-mailovou adresu bude odeslán e-mail s odkazem na obnovu (nastavení nového) zapomenutého hesla. </>
            </div>
            <Stack.Item>
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <PrimaryButton
                        text="Odeslat žádost o obnovu hesla"
                        disabled={auth.operationLoading}
                        onClick={handleSenedRequestClick}
                    />
                    <DefaultButton
                        text="Zpět"
                        onClick={handleCancelClick}
                    />
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

export default ResetPasswordRequestForm;
